import React from 'react'

import HttpServices from '../../utils/Http.services'
import { isLocalRolePreviewSession } from '../../utils/localRolePreview'
import './HorseBreederAgreementGate.css'

class HorseBreederAgreementGate extends React.Component {
    state = {
        loading: true,
        submitting: false,
        accepted: false,
        checked: false,
        agreement: null,
        acceptance: null,
        openClause: 0,
        error: null,
    }

    componentDidMount() {
        this.mounted = true
        this.loadAgreement()
    }

    componentDidUpdate(prevProps) {
        const previousUser = prevProps.user?.info
        const currentUser = this.props.user?.info
        if (
            previousUser?._id !== currentUser?._id
            || previousUser?.userType !== currentUser?.userType
        ) {
            this.loadAgreement()
        }
    }

    componentWillUnmount() {
        this.mounted = false
        this.unlockPage()
    }

    lockPage = () => {
        if (typeof document === 'undefined') return
        if (this.pageLocked) return
        this.previousBodyOverflow = document.body.style.overflow
        this.previousRootOverflow = document.documentElement.style.overflow
        document.body.style.overflow = 'hidden'
        document.documentElement.style.overflow = 'hidden'
        this.pageLocked = true
    }

    unlockPage = () => {
        if (typeof document === 'undefined') return
        if (!this.pageLocked) return
        document.body.style.overflow = this.previousBodyOverflow || ''
        document.documentElement.style.overflow = this.previousRootOverflow || ''
        this.pageLocked = false
    }

    loadAgreement = () => {
        const user = this.props.user?.info
        const applies = user?.userType === 'horseBreeder'

        if (!applies || isLocalRolePreviewSession(user)) {
            this.unlockPage()
            this.setState({ loading: false, accepted: true, error: null })
            return
        }

        this.lockPage()
        this.setState({
            loading: true,
            submitting: false,
            accepted: false,
            checked: false,
            agreement: null,
            acceptance: null,
            openClause: 0,
            error: null,
        })

        HttpServices.request('getHorseBreederAgreement', {}, (result, error) => {
            if (!this.mounted) return
            if (error || !result) {
                this.setState({
                    loading: false,
                    error: 'امکان دریافت متن قرارداد وجود ندارد. اتصال خود را بررسی و دوباره تلاش کنید.',
                })
                return
            }

            if (result.accepted || result.required === false) {
                this.unlockPage()
                this.setState({
                    loading: false,
                    accepted: true,
                    agreement: result.agreement || null,
                    acceptance: result.acceptance || null,
                    error: null,
                })
                return
            }

            this.setState({
                loading: false,
                accepted: false,
                agreement: result.agreement,
                acceptance: result.acceptance || null,
                error: null,
            })
        })
    }

    toggleClause = (index) => {
        this.setState(state => ({
            openClause: state.openClause === index ? null : index,
        }))
    }

    acceptAgreement = () => {
        const { agreement, checked, submitting } = this.state
        if (!agreement || !checked || submitting) return

        this.setState({ submitting: true, error: null })
        HttpServices.request('acceptHorseBreederAgreement', {
            accepted: true,
            agreementKey: agreement.key,
            version: agreement.version,
            documentHash: agreement.documentHash,
        }, (result, error) => {
            if (!this.mounted) return
            if (error || !result?.accepted) {
                if (error?.code === 'AGREEMENT_VERSION_MISMATCH') {
                    this.loadAgreement()
                    return
                }
                this.setState({
                    submitting: false,
                    error: error?.message || 'ثبت تأیید قرارداد انجام نشد. لطفاً دوباره تلاش کنید.',
                })
                return
            }

            this.unlockPage()
            this.setState({
                submitting: false,
                accepted: true,
                acceptance: result.acceptance || null,
                error: null,
            }, () => {
                if (this.props.onAccepted) {
                    this.props.onAccepted(result.acceptance || null)
                }
            })
        })
    }

    renderLoading() {
        return (
            <main className="ihp-agreement-screen" dir="rtl" aria-busy="true">
                <div className="ihp-agreement-loading" role="status">
                    <span className="ihp-agreement-spinner" />
                    <strong>در حال بررسی وضعیت قرارداد</strong>
                </div>
            </main>
        )
    }

    renderError() {
        return (
            <main className="ihp-agreement-screen" dir="rtl">
                <section className="ihp-agreement-error" role="alert">
                    <h1>خطا در دریافت قرارداد</h1>
                    <p>{this.state.error}</p>
                    <button type="button" onClick={this.loadAgreement}>تلاش مجدد</button>
                </section>
            </main>
        )
    }

    renderAgreement() {
        const { agreement, checked, submitting, openClause, error } = this.state
        const user = this.props.user?.info || {}

        return (
            <main className="ihp-agreement-screen" dir="rtl">
                <section
                    className="ihp-agreement-dialog"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="horse-breeder-agreement-title"
                    aria-describedby="horse-breeder-agreement-intro"
                >
                    <header className="ihp-agreement-header">
                        <img src="/images/kheiry/mainLogo.png" alt="Iran Horse Promotion" />
                        <div>
                            <span>ورود به پنل پرورش‌دهنده</span>
                            <h1 id="horse-breeder-agreement-title">{agreement?.title}</h1>
                            <p>{[user.name, user.family].filter(Boolean).join(' ') || user.username}</p>
                        </div>
                    </header>

                    <div className="ihp-agreement-scroll">
                        <p id="horse-breeder-agreement-intro" className="ihp-agreement-intro">
                            {agreement?.introduction}
                        </p>

                        <div className="ihp-agreement-meta">
                            <span>نسخه {agreement?.version}</span>
                            <span>{agreement?.clauses?.length || 0} بند</span>
                        </div>

                        <div className="ihp-agreement-clauses">
                            {(agreement?.clauses || []).map((clause, index) => {
                                const isOpen = openClause === index
                                const panelId = `horse-breeder-agreement-clause-${index}`
                                return (
                                    <article className={`ihp-agreement-clause ${isOpen ? 'is-open' : ''}`} key={panelId}>
                                        <button
                                            type="button"
                                            aria-expanded={isOpen}
                                            aria-controls={panelId}
                                            onClick={() => this.toggleClause(index)}
                                        >
                                            <span>بند {index + 1}</span>
                                            <span aria-hidden="true">{isOpen ? '−' : '+'}</span>
                                        </button>
                                        {isOpen && <p id={panelId}>{clause}</p>}
                                    </article>
                                )
                            })}
                        </div>

                        <section className="ihp-agreement-payment">
                            <h2>مبلغ و نحوه پرداخت</h2>
                            {(agreement?.paymentTerms || []).map((term, index) => (
                                <p key={`payment-term-${index}`}>{term}</p>
                            ))}
                        </section>
                    </div>

                    <footer className="ihp-agreement-footer">
                        {error && <p className="ihp-agreement-inline-error" role="alert">{error}</p>}
                        <label className="ihp-agreement-confirmation">
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={event => this.setState({ checked: event.target.checked })}
                            />
                            <span>تمام بندهای قرارداد را خواندم و با آن‌ها موافقم.</span>
                        </label>
                        <button
                            type="button"
                            className="ihp-agreement-accept"
                            disabled={!checked || submitting}
                            onClick={this.acceptAgreement}
                        >
                            {submitting ? 'در حال ثبت...' : 'تأیید قرارداد و ورود به پنل'}
                        </button>
                        <small>تا زمان تأیید، امکان ورود به پنل وجود ندارد.</small>
                    </footer>
                </section>
            </main>
        )
    }

    renderProtectedPanel() {
        if (!React.isValidElement(this.props.children)) {
            return this.props.children || null
        }

        const stageNavigation = {}
        const navigationKeys = ['lastStage', 'nextStage', 'changeStage']
        navigationKeys.forEach((key) => {
            if (typeof this.props[key] === 'function') {
                stageNavigation[key] = this.props[key]
            }
        })

        return React.cloneElement(this.props.children, stageNavigation)
    }

    render() {
        if (this.state.accepted) return this.renderProtectedPanel()
        if (this.state.loading) return this.renderLoading()
        if (this.state.error && !this.state.agreement) return this.renderError()
        return this.renderAgreement()
    }
}

export default HorseBreederAgreementGate
